<template>
  <div class="two-col-content row">
    <div class="settings-holder">
      <h1 class="headerone__default__large">Settings</h1>
      <div class="settings-holder-inner">

        <el-radio-group v-model="profileId">
          <el-radio-button v-for="profile in statsProfiles" :key="profile.id" :value="profile.id" :label="profile.id">
            <span class="name">{{ profile.name }}</span>
            <span class="columns"><p>{{ profile.columns }}</p></span>
          </el-radio-button>
        </el-radio-group>

        <div class="profile-select-holder">
          <el-button type="primary" @click="save()" class="btn__default">Save</el-button>
          <transition name="fade" mode="out-in">
            <div class="campaign-loader" v-if="loading">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                    <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <button @click="close" class="close-settings"><i class="el-icon-close"></i></button>
  </div>
</template>

<script>
import { Notification } from 'element-ui'

export default {
  name: 'setting',
  data() {
    return {
      loading: false,
      profileId: null,
      fromRoute: null
    }
  },
  computed: {
    endpoint() {
      return this.$store.getters.affiliateBaseEndpoint + '/profile'
    },
    statsProfiles(el) {
      let result = []
      for (var i = 0; i < this.$store.state.cache.profileList.length; i++) {
        result.push({
          'id': this.$store.state.cache.profileList[i].id,
          'name': this.$store.state.cache.profileList[i].name,
          'columns': JSON.parse(this.$store.state.cache.profileList[i].config).stats.join(', ').replace(/[/_/]/g, ' ')
        })

        result[i].columns = result[i].columns.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")

      }
      return result
    }
  },
  created() {
    this.$store.dispatch('retrieveProfileList')
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.$http.get(this.endpoint, {requestId: 'setting-initialization', context: this._uid})
        .then((response) => {
          this.profileId = response.data.data.id
        }).catch((error) => {
          if (this.$http.isApiError(error))
            this.profileId = null
        })
    },
    save() {
      this.loading = true
      let params = new URLSearchParams({ profile_id: this.profileId })
      let success = false

      this.$http.put(this.endpoint, params).then((response) => {
        this.loading = false

        Notification({
          title: 'Success',
          message: 'Successfully saved!',
          type: 'success',
          position: 'bottom-right'
        })
      }).catch((error) => {
        this.loading = false
        let message = 'An error has occurred. Please try again later'

        if (this.$http.isApiError(error))
          message = error.response.data._meta.errors.join(', ')

        Notification.error({
          title: 'Error',
          message: message,
          position: 'bottom-right'
        })
      })
    },
    close() {
      if (this.from.name)
        this.$router.back()
      else
        this.$router.push('performance')
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from
    })
  }
};
</script>

<style lang="scss" scoped>
.two-col-content{
  background: #f9f9f9;
}
.headerone__default__large{
    font-size: 32px;
    font-family: "Interface", Arial;
    line-height: normal;
    margin-bottom: 15px;
    font-weight: bold;
}
.settings-holder{
  width: 675px;
  margin: 50px auto;
  .settings-holder-inner{
    padding: 25px 0;
    /* background: #fff; */
    /* box-shadow: 0 1px 1px 0 rgba(0,0,0,.3); */

    .profile-select-holder{
      padding: 20px 0 0 0;
    }
  }
}
/*====
 *
 ** SETTINGS
 *
   ====*/
.settings-holder{
  /deep/ .el-radio-group{
    width: 100%;
    display: block;

    .el-radio-button,
    .el-radio-button__inner{
      width: inherit;
      display: inherit;
    }
    .el-radio-button__inner{
      border: none;
      box-shadow: 0 1px 1px 0 rgba(0,0,0,.3) !important;
      border-radius: 0;
      margin-bottom: 10px;
      text-align: left;
      padding: 15px 15px;
    }
    .name,
    .columns{
      display: inline-block;
      vertical-align: middle;
    }
    .name{
      width: 15%;
    }
    .columns{
      padding: 0 10px;
      white-space: normal;
      line-height: 20px;
      width: 84%;

    }
  }
  .btn__default{
    float: right;
  }
}
.close-settings{
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 50px;
  background: transparent;
  color: #aaa;
  border: none;
  display: block;
  cursor: pointer;
}
@media(min-width: 1199px){
  .two-col-content{
    width: 100%;
    padding-left: 250px !important;
  }
}

/*====
 *
 ** Control Styles
 *
   ====*/
.campaign-loader{
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  .el-icon-loading{
    position: absolute;
    top: calc(50%);
    left: calc(50%);
  }
}
.fade-enter-active,
.fade-enter-to {
  opacity: 1;
  transition: none;
}
.fade-leave-active,
.fade-leave-to{
  opacity: 0;
  transition: opacity .4s;
}
</style>



// WEBPACK FOOTER //
// setting.vue?54524ff0